import { render, staticRenderFns } from "./ContactsManagement.vue?vue&type=template&id=07f23b60&scoped=true"
import script from "./ContactsManagement.vue?vue&type=script&lang=js"
export * from "./ContactsManagement.vue?vue&type=script&lang=js"
import style0 from "./ContactsManagement.vue?vue&type=style&index=0&id=07f23b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f23b60",
  null
  
)

export default component.exports